// Shared profile constants + helpers used by both the /intake page and the
// landing-page intake widget, so the structured profile stays consistent.

// Role categories — these double as the keyword "families" the scorer uses.
export const CATEGORIES = [
  "Backend", "Frontend", "Full-Stack", "Data", "ML / AI", "DevOps / Cloud",
  "Mobile", "QA / Test", "Security", "Product", "Design", "Marketing",
  "Sales", "Operations", "Finance", "HR", "Other",
];

export const LEVEL_LABELS = {
  entry: "Entry / Fresher", junior: "Junior", mid: "Mid-level",
  senior: "Senior", lead: "Lead / Principal",
};

// Mirror of the backend year→level bands (scoring_engine.resolve_level).
export function deriveLevel(years) {
  if (years === "" || years === null || years === undefined || isNaN(years)) return "";
  const y = Number(years);
  if (y < 1) return "entry";
  if (y < 3) return "junior";
  if (y < 6) return "mid";
  if (y < 10) return "senior";
  return "lead";
}
